import React from "react";
import { Route } from "react-router-dom";
import CallBack from "./components/callback/Callback";
import ConfigWithPermissions from "./components/config/Config";
import Help from "./components/help/Help";
import OssLicense from "./components/oss/OssLicense";

export default [
  <Route exact path="/callback" component={CallBack} />,
  <Route exact path="/config" component={ConfigWithPermissions} />,
  <Route exact path="/help" component={Help} />,
  <Route exact path="/oss" component={OssLicense} />,
];
